import { httpGet } from "@eres/rest";
import { ProcedureDetailResponse } from "@10x/tabu-mobile-api/dist/requests/entity";
import {Buffer} from "buffer";
import { TabuMobileConfig } from "@10x/tabu-mobile-api";

declare type WeirdTabuIds = string | number;
export function getProcedureDetailsXX(ProcedureNumber: WeirdTabuIds, ProcedureYear: WeirdTabuIds, ProcedureId: WeirdTabuIds): Promise<ProcedureDetailResponse> {
	const encoded = Buffer.from(ProcedureId + "-" + ProcedureYear + "-" + ProcedureNumber, "utf-8").toString("base64");
	return httpGet( `${TabuMobileConfig.tabuAPI().endPoint() }tabu/GetTabuRequestDetails?refNumber=${encoded}`);
}
